export enum AutomationSourceType {
  Payin = 'payin',
  Spam = 'spam',
}
